import {
  createStandardAction,
  ActionType,
  createReducer,
} from 'typesafe-actions';

/**
 * UI 리덕스
 */

const IS_CHAT = 'ui/IS_CHAT';
const IS_EDITANGLE = 'ui/IS_EDITANGLE';
const EDIT_MODE = 'ui/EDIT_MODE';

export const isChatAction = createStandardAction(IS_CHAT)<boolean>();
export const isEditangleAction = createStandardAction(IS_EDITANGLE)<boolean>();
export const editModeAction = createStandardAction(EDIT_MODE)<string>();

type actions = {
  isChatAction: typeof isChatAction;
  isEditangleAction: typeof isEditangleAction;
  editModeAction: typeof editModeAction;
};
type TUiAction = ActionType<actions>;

type TUiState = {
  isChat: boolean;
  isEditangle: boolean;
  editMode: string;
};

const initialState: TUiState = {
  isChat: true,
  isEditangle: false,
  editMode: '',
};

const ui = createReducer<TUiState, TUiAction>(initialState, {
  [IS_CHAT]: (state, action) => ({
    ...state,
    ...action,
    isChat: action.payload,
  }),
  [IS_EDITANGLE]: (state, action) => ({
    ...state,
    ...action,
    isEditangle: action.payload,
  }),
  [EDIT_MODE]: (state, action) => ({
    ...state,
    ...action,
    editMode: action.payload,
  }),
});

export default ui;
